import { HttpParams } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CheckBoxSelection } from '@syncfusion/ej2-dropdowns';

import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';
import { NgxLinkifyOptions } from 'ngx-linkifyjs-v2';
import { Category, Subcategory, User, UserService } from '../../core';
import { LoaderService } from '../../core/loader.service';
import { ElectionDate } from '../../core/models/electionDate.model';
import { Profile } from '../../core/models/profile.model';
import { Representative } from '../../core/models/representative.model';
import { Review } from '../../core/models/review.model';
import { AuthService } from '../../core/services/auth.service';
import { ProfileService } from '../../core/services/profile.service';
//import { Appearance } from '@angular-material-extensions/google-maps-autocomplete';
import PlaceResult = google.maps.places.PlaceResult;
//import { AgmMap, MapsAPILoader } from '@agm/core';
import { MapsAPILoader } from '@ng-maps/core';
import { State } from '../../core/models/state.model';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { ShareModalComponent } from '../share-modal/share-modal/share-modal.component';
import { DesignService } from 'src/app/core/services/design.service';
import { ReportBugFeedbackDTO } from '../../core/models/reportBugFeedback.modal';
import { NgForm } from '@angular/forms';


declare var $: any;
declare var Veriff: any;
@Component({
  selector: 'app-representative-search',
  templateUrl: './representative-search.component.html',
  styleUrls: ['./representative-search.component.scss'],
})
export class RepresentativeSearchComponent implements OnInit {
  lat: any;
  lng: any;

  public selectedImg: any = '../../../assets/images/noprofile2.png'; // default snowman image set
  search = false; // flag to indicate if search operation performed.
  notFound = false; // flag to indicate that profile searched is not found.
  profileList = new Array<Profile>(); // Get Searched profile list
  searchValue = ''; // store value entered by user
  searchSuggetionList = []; // Store list of suggetions
  trendingReviewList = new Array<Review>(); // store tranding review list
  trendingReviewLoading = false; // Show Loading for tranding review
  navigation: any;
  trendingReviewActive = 'ALL';
  recentSearch = new Array();
  recentFirst: boolean = false;
  categoryList = new Array<Category>();
  selectedCategoryId: number[] = []; // list of category
  selectedCategory = new Category();
  subcategoryList = new Array<Subcategory>(); // List of subcategory
  selectedSubcategoryId: number[] = []; // Used for getting the selected subcategories ID for multiselectdropdown
  subcategoryListForDataSource = [];
  selectedCategoryList = new Array<Category>(); // the subcategories that has been selected in the dropdown.
  categoryFilterList = new Array<string>();
  subCategoryFilterList = new Array<string>();
  officeProfileList = new Array<Representative>();
  stateList = new Array<Representative>();
  localList = new Array<Representative>();
  countryList = new Array<Representative>();
  checkRepresentative = true;
  searchstring: string = '';
  zoom = 4;
  isLoading = false;
  getAddress: any;
  loader = true;
  // public appearance = Appearance;
  public latitude!: number;
  public longitude!: number;
  public selectedAddress!: PlaceResult;
  featureReview: boolean = true;
  reviewDivHeight: any;
  user: User = new User();
  election: boolean = false;
  trendingReview: boolean = false;
  id: any;
  representativeList: Array<string> = [];

  // check user id fully verified or not
  fullyVerified = false;
  existPhoneNumber = false;
  validAge: boolean = true;
  veriffVerified = false;
  veriffStatus: string = '';
  veriffSessionId: any;
  veriffErrMsg: string[] = [];

  locationList = new Array<Representative>();
  locationListActive = 'LOCAL';
  avtarStyle = {
    borderRadius: '0px',
    color: 'var(--gray-color)',
    backgroundColor: 'var(--light-gray-color)',
    cursor: 'pointer',
    width: '7rem',
    height: '7rem',
    fontSize: '3rem',
    fontFamily: 'var(--default-font-family)',
    display: 'grid',
    alignContent: 'center',
    padding: '0',
    margin: '0',
    lineHeight: '1',
  };
  statesList = new Array<State>();
  selectedState: string = '';
  electionDates = new Array<ElectionDate>();

  @ViewChild('multiselectcheckbox')
  public multiselectcheckbox!: CheckBoxSelection;
  // @ViewChild(AgmMap)
  // public agmMap!: AgmMap;

  @ViewChild('mapView', { static: false })
  mapView!: any;

  @ViewChild('searchString') searchElementRef!: ElementRef;
  @ViewChild('shareModal') shareModal!: ShareModalComponent;

  options: NgxLinkifyOptions = {
    className: '',
    attributes(href: any, type: string) {
      type = 'linkify linkify-' + type;
      return { routerLink: href, class: type };
    },
    formatHref(href, type) {
      if (type === 'mention') {
        href = '/profile/view-profile/' + href.substring(1);
      }
      return href;
    },
    ignoreTags: ['script', 'style'],
    nl2br: true,
  };
  activeTab: 'featureReview' | 'trendingReview' | 'election' = 'trendingReview';

  currentLocation = '';
  currentUrl = '';
  reportBugFeedbackDTO: ReportBugFeedbackDTO = new ReportBugFeedbackDTO();
  isAutocompleteInitialized = false; // Flag to check if autocomplete is initialized


  constructor(
    public session: SessionStorageService,
    private profileService: ProfileService,
    private loaderService: LoaderService,
    private router: Router,
    private apiloader: MapsAPILoader,
    private authService: AuthService,
    private userService: UserService,
    private designService: DesignService,
  ) {
    // this.designService.setHeaderStyle('profile');
  }

  ngOnInit() {
    this.user = this.authService.getUser();

    const location = this.session.get('location');
    const tab = this.session.get('tab');
    this.fetchStateList();

    // Initialize latitude and longitude
    this.lat = this.session.get('latitude') || 37.09024;
    this.lng = this.session.get('longitude') || -95.712891;

    // Initialize zoom
    this.zoom = 4; // Default zoom value
    if (tab != undefined) {
      this.activeTab = this.session.get('tab');
      if (this.activeTab == 'trendingReview') {
        const activeTrendingReview = this.session.get('activeTrendingReview');
        if (activeTrendingReview != undefined) {
          this.getTrendingReviewsByLevel(activeTrendingReview);
        } else {
          this.getTrendingReviewsByLevel('ALL');
        }
      }
      if (this.activeTab == 'election') {
        const state = this.session.get('state');
        if (state != undefined) {
          this.searchstring = '';
          this.selectedState = state;
          this.fetchElectionDates();
        } else {
          this.lat = this.session.get('latitude');
          this.lng = this.session.get('longitude');
          if (
            this.lat == undefined ||
            this.lng == undefined ||
            this.lat == null ||
            this.lng == null
          ) {
            this.lat = 37.09024;
            this.lng = -95.712891;
          }

          this.searchstring = this.session.get('locationName');
          this.fetchElectionDates();
        }
      }
      if (this.activeTab == 'featureReview') {
        console.log(
          'TCL: RepresentativeSearchComponent -> ngOnInit -> location',
          location
        );
        const locationname = this.session.get('locationName');
        console.log(
          'TCL: RepresentativeSearchComponent -> ngOnInit -> locationname',
          locationname
        );
        if (!locationname) {
          if (
            location === undefined ||
            location === null ||
            location === true
          ) {
            this.get();
          } else {
            //this.lat = 37.09024;
            //this.lng = -95.712891;
            //this.zoom = 4;
            //this.searchstring = 'United States';
            //this.session.set('locationName', 'United States');
            this.searchProfile();
          }
        } else {
          this.searchstring = locationname;
          this.getLocation();
        }
      }
    } else {
      this.getTrendingReviewsByLevel('ALL');
      this.lat = 37.09024;
      this.lng = -95.712891;
      console.log(
        'TCL: RepresentativeSearchComponent -> ngOnInit -> location',
        location
      );
      const locationname = this.session.get('locationName');
      console.log(
        'TCL: RepresentativeSearchComponent -> ngOnInit -> locationname',
        locationname
      );
      if (!locationname) {
        if (location === undefined || location === null || location === true) {
          this.get();
        } else {
          //this.lat = 37.09024;
          // this.lng = -95.712891;
          // this.zoom = 4;
          // this.searchstring = 'United States';
          // this.session.set('locationName', 'United States');
          this.searchProfile();
        }
      } else {
        this.searchstring = locationname;
        this.getLocation();
      }
    }

    // this.mapView.triggerResize(true);
    if (this.mapView) {
      // Assuming the map instance is accessible via this.mapView.map
      google.maps.event.trigger(this.mapView.map, 'resize');
      // Optionally, you can reset the center if needed
      this.mapView.map.setCenter({ lat: this.lat, lng: this.lng });
    }
  }

  ngAfterViewChecked(): void {
    if (this.isAutocompleteInitialized) {
      return; // Prevent running the code again if already initialized
    }

    // Check if the search element is available
    if (this.searchElementRef && this.searchElementRef.nativeElement) {
      console.log('Search input element found:', this.searchElementRef.nativeElement);
      // Set the flag to true to prevent infinite loop
      this.isAutocompleteInitialized = true;

      // Load the Google Maps API
      this.apiloader.load().then(() => {
        console.log('Google Maps API loaded');

        // Attach autocomplete to the input field
        const autocomplete = new google.maps.places.Autocomplete(
          this.searchElementRef.nativeElement,
          { types: ['geocode'] } // Restrict suggestions to locations
        );
        console.log('Autocomplete initialized');

        // Add a listener to capture place selection
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          console.log('Place changed:', place);
          this.onAutocompleteSelected(place);

          if (place.geometry && place.geometry.location) {
            const location = {
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng(),
            };
            // Call your custom method with the location data
            this.onLocationSelected(location);
          }
        });
      }).catch((error) => {
        console.error('Error loading Google Maps API:', error);
      });
    } 
  }

  onAutocompleteSelected(result: any) {
    console.log('Result :: ', result);
    this.selectedState = '';
    this.zoom = 8;
    if (result.formatted_address != undefined) {
      this.searchstring = result.formatted_address;
    }
    this.session.set('locationName', this.searchstring);
    this.searchProfile();
    this.fetchElectionDates();
  }

  onLocationSelected(location: any) {
    console.log('Location :: ', location);
    this.selectedState = '';
    this.session.set('locationName', this.searchstring);
    this.lat = location.latitude;
    this.lng = location.longitude;
    this.session.set('latitude', this.lat);
    this.session.set('longitude', this.lng);
    this.fetchElectionDates();
  }

  changeLocation(searchstring: string) {
    this.selectedState = '';
    this.searchstring = searchstring;
    this.session.set('locationName', this.searchstring);
    this.searchProfile();
    this.fetchElectionDates();
  }

  get() {
    let errCode: number;
    if (navigator.geolocation) {
      let currentAdd: string;
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          //  this.loaderService.show();
          this.isLoading = true;
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;

            this.getAddress = (this.lat, this.lng);

            console.log('Get Address :: ' + this.getAddress);

            console.log('Position :: ' + position);
            this.apiloader.load().then(() => {
              const geocoder = new google.maps.Geocoder();
              const latlng = {
                lat: this.lat,
                lng: this.lng,
              };
              geocoder.geocode(
                {
                  location: latlng,
                },
                function (results, status) {
                  if (
                    status === google.maps.GeocoderStatus.OK &&
                    results &&
                    results.length > 0
                  ) {
                    console.log('Location: ' + results[0].formatted_address);
                    currentAdd = results[0].formatted_address;
                  } else {
                    console.log('Location not found');
                  }
                }
              );
              setTimeout(() => {
                this.searchstring = currentAdd;
                this.zoom = 4;
                this.session.set('location', true);
                this.session.set('locationName', this.searchstring);
                if (this.searchstring != 'United States') {
                  this.searchProfile();
                }
                this.fetchElectionDates();
                this.isLoading = false;
              }, 2500);
            });
          }
        },
        function (error) {
          if (error.code === error.PERMISSION_DENIED) {
            errCode = error.code;
            console.log('you denied me :(');
          }
        }
      );
    }
    setTimeout(() => {
      if (errCode === 1) {
        this.session.set('location', false);
        this.session.set('locationName', this.searchstring);
        //this.lat = 37.09024;
        //this.lng = -95.712891;
        // this.zoom = 4;
        //this.searchstring = 'United States';
        this.searchProfile();
        this.fetchElectionDates();
      }
    }, 2500);
  }

  mapClicked($event: MouseEvent) {
    // Update latitude and longitude with event coordinates if necessary
    // this.latitude = $event.coords.lat;
    // this.longitude = $event.coords.lng;

    this.apiloader.load().then(() => {
      const geocoder = new google.maps.Geocoder();
      const latlng = {
        lat: this.latitude,
        lng: this.longitude,
      };

      geocoder.geocode({ location: latlng }, (results, status) => {
        // Use an arrow function here
        if (
          status === google.maps.GeocoderStatus.OK &&
          results &&
          results.length > 0
        ) {
          this.currentLocation = results[0].formatted_address;
          console.log(this.currentLocation);
        } else {
          console.log('Not found');
        }
      });
    });
  }

  searchLocationByName(locationName: string) {
    this.apiloader.load().then(() => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: locationName,
        },
        (results, status) => {
          if (status === 'OK' && results && results[0]) {
            this.lat = results[0].geometry.location.lat();
            this.lng = results[0].geometry.location.lng();
            this.session.set('latitude', this.lat);
            this.session.set('longitude', this.lng);

            console.log('Latitude:', this.lat);
            console.log('Longitude:', this.lng);
            this.changeLocation(locationName);
          } else {
            console.log('Location not found');
          }
        }
      );
    });
  }
  searchProfile() {
    console.log('API CALLED :: ' + this.searchstring);
    // this.loaderService.disable = true;
    this.locationList = [];
    this.officeProfileList = [];
    this.stateList = [];
    this.countryList = [];
    this.localList = [];
    if (this.searchValue === '') {
      this.recentFirst = true;
    }
    if (
      this.searchstring !== undefined &&
      this.searchstring !== null &&
      this.searchstring !== '' &&
      this.searchstring.length > 1
    ) {
      const params = new HttpParams().set('address', this.searchstring); // getting profile Id from route.
      this.loaderService.disable = true;
      this.profileService.getReprentatives(params).subscribe(
        (success) => {
          this.locationList = [];
          this.officeProfileList = [];
          this.stateList = [];
          this.countryList = [];
          this.localList = [];
          console.log(success);
          this.officeProfileList = success.data;
          console.log(JSON.stringify(this.officeProfileList));
          if (this.officeProfileList != null) {
            this.officeProfileList.forEach((element) => {
              this.checkRepresentative = true;
              //console.log('Element : ',element);
              const temp: string = element.photoUrl;

              if (element.level === 'country') {
                this.countryList.push(element);
              }
              if (element.level === 'administrativeArea1') {
                this.stateList.push(element);
              }
              if (
                element.level === 'administrativeArea2' ||
                element.level === 'locality'
              ) {
                this.localList.push(element);
              }
            });
            this.getLocationLists('LOCAL');
            this.loader = false;
          } else {
            this.loader = false;
            this.checkRepresentative = false;
          }
        },
        (error) => {
          console.log('Error On Search :', error);
        }
      );
    }
  }

  getLocationLists(type: string) {
    this.locationListActive = type;

    switch (type) {
      case 'LOCAL':
        this.locationList = this.localList;
        if (this.localList.length === 0) {
          this.getLocationLists('STATE');
        }
        break;

      case 'STATE':
        this.locationList = this.stateList;
        if (this.stateList.length === 0) {
          this.getLocationLists('NATIONAL');
        }
        break;

      case 'NATIONAL':
        this.locationList = this.countryList;
        break;

      default:
        break;
    }
  }

  getLocation() {
    console.log(this.searchstring);
    if (this.searchstring.startsWith(' ') || this.searchstring.endsWith(' ')) {
      return;
    } else {
      this.session.set('locationName', this.searchstring);
      this.getLatLngByZipcode(this.searchstring);
    }
  }

  getLatLngByZipcode(zipcode: string) {
    const geocoder = new google.maps.Geocoder();
    const address = zipcode;
    let lat: any;
    let lng: any;
    geocoder.geocode(
      { address: 'zipcode ' + address },
      function (results, status) {
        if (
          status === google.maps.GeocoderStatus.OK &&
          results &&
          results.length > 0
        ) {
          lat = results[0].geometry.location.lat();
          lng = results[0].geometry.location.lng();
        } else {
          console.log('Geocoding failed or no results found');
        }
      }
    );

    setTimeout(() => {
      this.setMarker(lat, lng);
    }, 2500);
  }

  setMarker(lat: number, lng: number) {
    this.zoom = 8;
    this.lat = lat;
    this.lng = lng;
    this.searchProfile();
  }

  checkProfile(profile: any) {
    console.log(profile);
    this.loaderService.disable = true;
    profile.civic = true;
    profile.profileType = 'candidate';
    this.profileService
      .checkAndSaveReprentatives(profile)
      .subscribe((success) => {
        console.log('res : ', success);
        let uri = '/profile/view-profile/' + success.data.tagname;
        this.router.navigateByUrl(uri);
      });
  }

  // to get trending reviews
  async getTrendingReviews() {
    this.trendingReviewActive = 'ALL';
    if (
      this.searchValue === undefined ||
      this.searchValue === null ||
      this.searchValue === ''
    ) {
      this.loaderService.disable = true;
      this.profileService.getTrendingReviews().subscribe(
        (success) => {
          this.trendingReviewList = success.data;
          this.trendingReviewLoading = true;
          if (!!this.trendingReviewList) {
            this.trendingReviewList.forEach((element) => {
              // if (element.content.length >= 100) {
              //   element.content =
              //     element.content + "<button class='btn btn-link btn-link-theme read-more'>Read More</button>";
              // }
            });
          }
        },
        (error) => {
          console.log('Error Loading Trending Reviews', error);
        }
      );
    }
  }

  getTrendingReviewsByLevel(type: string) {
    this.trendingReviewActive = type;
    this.session.set('activeTrendingReview', this.trendingReviewActive);
    var profileId;
    this.user != null && this.user.defaultProfileId != null
      ? (profileId = this.user.defaultProfileId)
      : (profileId = '');
    const reviewDiv: any = document.querySelector('#reviewDiv');
    //reviewDiv.style.height = `${reviewDiv.offsetHeight}px`;

    let levelStr: string;

    // if (type === 'LOCAL') {
    //   levelStr = 'local';
    // } else if (type === 'STATE') {
    //   levelStr = 'state';
    // } else if (type === 'NATIONAL') {
    //   levelStr = 'national';
    // } else if (type === 'ALL') {
    //   levelStr = 'all';
    // }

    this.trendingReviewList = [];
    let params = new HttpParams().set('profileId', profileId);

    if (type === 'MY AREA') {
      if (this.user.city != null) {
      params = params.append('city', this.user.city);
      } else {
        params = params.append('city', 'null');
      }
    }
    // this.loaderService.disable = true;
    this.profileService.getReviewLevel(params).subscribe(
      (success) => {
        this.trendingReviewList = success.data;
        console.log(
          'TCL: HomepageComponent -> getTrendingReviewsByLevel -> success',
          success
        );
        this.trendingReviewLoading = true;
        if (!!this.trendingReviewList) {
          this.trendingReviewList.forEach((element) => {
            if (element.content.length >= 100) {
              // element.content =
              //   element.content + "<button class='btn btn-link btn-link-theme read-more'>Read More</button>";
            }
          });
        }
        //reviewDiv.style.height = 'auto';
        this.reviewDivHeight = 'auto';
      },
      (error) => {
        console.log('Error Loading Trending Reviews', error);
        reviewDiv.style.height = 'auto';
      }
    );
  }

  changeFeatureTrending(result: any) {
    if (result == 'Feature Review') {
      this.featureReview = true;
      this.election = false;
      this.trendingReview = false;
      this.activeTab = 'featureReview';
      this.session.set('tab', this.activeTab);
    } else {
      console.log('Trending review');
      this.getTrendingReviewsByLevel('ALL');
      this.featureReview = false;
      this.election = false;
      this.trendingReview = true;
      this.activeTab = 'trendingReview';
      this.session.set('tab', this.activeTab);
    }
  }

  redirectToViewResponsePage(id: any) {
    // if (this.user != null && this.user.verified == false) {
    //   alert('You must be a verified user to able to share a review');
    // } else {
      let uri = '/profile/view-response/' + id;
      this.router.navigateByUrl(uri);
    // }
    // if (this.user == null) {
    // this.authService.removeLogFlag();
    // this.authService.removeCookie();
    // this.router.navigateByUrl('/login');
    // }
  }

  // Purpose : To display election section
  displayElections() {
    this.featureReview = false;
    this.election = true;
    this.trendingReview = false;
    this.activeTab = 'election';
    this.session.set('tab', this.activeTab);
  }

  // Purpose : To fetch state list
  fetchStateList() {
    this.profileService.fetchStateList().subscribe((res) => {
      if (res.success === 0) {
        this.statesList = res.data;
      }
    });
  }

  // Purpose : To fetch state list
  fetchElectionDates() {
    this.electionDates = [];
    var params = new HttpParams();
    if (this.selectedState != null && this.selectedState != '') {
      params = params.append('state', this.selectedState.toString());
      params = params.append('year', new Date().getFullYear().toString());
      this.session.set('state', this.selectedState);
      this.session.set('latitude', null);
      this.session.set('longitude', null);
    } else {
      params = params.append('latitude', this.lat);
      params = params.append('longitude', this.lng);
      this.session.set('latitude', this.lat);
      this.session.set('longitude', this.lng);
      this.session.set('state', null);
    }
    this.profileService.fetchElectionDates(params).subscribe((res) => {
      if (res.success === 0) {
        this.electionDates = res.data;
        this.electionDates = this.electionDates.filter(
          (obj) => obj.electionName.length != 0
        );
        console.log('electionDates:' + JSON.stringify(this.electionDates));
      }
    });
  }

  // Purpose : To view state on Map
  searchStateByName(locationName: string) {
    var state = this.statesList.find((obj) => obj.isoCode == locationName);
    this.apiloader.load().then(() => {
      if (state != undefined) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          {
            address: `${state.stateName}, USA`,
          },
          (results, status) => {
            if (status === 'OK' && results && results[0]) {
              this.lat = results[0].geometry.location.lat();
              this.lng = results[0].geometry.location.lng();
              this.zoom = 4;
              console.log('Latitude:', this.lat);
              console.log('Longitude:', this.lng);
            } else {
              console.log('Location not found');
            }
          }
        );
      }
    });
  }

  //Purpose : To save election details in session and redirect to election detail page
  redirectToElectionDetailPage(electionDetails: ElectionDate) {
    this.session.set('electionDetails', electionDetails);
    this.router.navigateByUrl('/election-details');
  }

  // Purpose : To format date
  formatDate(date: string): string {
    const datePipe = new DatePipe('en-US');
    const formattedDate = datePipe.transform(date, 'MMMM d, yyyy');

    // Check if formattedDate is null
    if (!formattedDate) {
      return 'Invalid date'; // or handle it as needed
    }

    const dateParts = formattedDate.split(' ');
    const day = parseInt(dateParts[1].replace(',', ''), 10);

    let suffix = 'th';
    if (day % 10 === 1 && day !== 11) {
      suffix = 'st';
    } else if (day % 10 === 2 && day !== 12) {
      suffix = 'nd';
    } else if (day % 10 === 3 && day !== 13) {
      suffix = 'rd';
    }

    dateParts[1] = `${day}${suffix}`;
    return `${dateParts[0]} ${dateParts[1]}, ${dateParts[2]}`;
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    console.log('scrolll event.......');
    const element = event.target;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 1) {
      console.log('scroll called' + this.loader);
    }
  }

  redirectToResponsePage(id: any) {
    // Check if the user is null
    //    if (this.user == null) {
    //     this.authService.removeLogFlag();
    //     this.authService.removeCookie();
    //     this.router.navigateByUrl('/login');
    //     return;
    // }

    // Check if the user is not verified
    // if (this.user != null && this.user.verified == false) {
    //   alert('You must be a verified user to be able to share a review');
    //   return;
    // }

    // Check if the user is verified but has no default profile ID
    // if (this.user !=null && this.user.verified == true && this.user.defaultProfileId == null && this.user.reviewProfileId == null)  {
    //     $('#restrictResponseModals').modal('show');
    //     return;
    // }

    // Check if the user is verified and claim process is under review
    //   if (this.user !=null && this.user.verified == true && this.user.defaultProfileId == null && this.user.reviewProfileId != null)  {
    //     $('#restrictUnclaimedProfileResponseModals').modal('show');
    //     return;
    // }

    // Redirect to the response page if all conditions are met
    let uri = '/profile/view-response/' + id;
    this.router.navigateByUrl(uri);
  }

  redirectPage(id: any) {
    if (this.user == null) {
      this.authService.removeLogFlag();
      this.authService.removeCookie();
      this.router.navigateByUrl('/login');
      return;
    }

    // Check if the user is not verified
    // if (this.user.verified == false) {
    //   alert('You must be a verified user to be able to share a review');
    //   return;
    // }
    if (!this.user.verified) {
      $('#restrictModal').modal('show');
      return;
    }

    const review = this.trendingReviewList.find(obj => obj.id == id);
    if (this.user != null && review != undefined && review.isConstituentsOnlyReply) {
      this.representativeList = this.authService.getRepresentativeList();
      if (this.user.address != null) {
        var representativeExists = this.representativeList.find(obj => obj == review.byProfileTagName);
        if (!representativeExists && this.user.city != review.city) {
          $('#conversationErrorModal').modal('show');
          return;
        }
      } else {
        $('#conversationAlertModal').modal('show');
        return;
      }
    }

    // Check if the user is verified but has no default profile ID
    // if (this.user.verified == true && this.user.defaultProfileId == null && this.user.reviewProfileId == null) {
    //     $('#restrictResponseModals').modal('show');
    //     return;
    // }

    // Check if the user is verified and claim process is under review
    //   if (this.user !=null && this.user.verified == true && this.user.defaultProfileId == null && this.user.reviewProfileId != null)  {
    //     $('#restrictUnclaimedProfileResponseModals').modal('show');
    //     return;
    // }
    // Redirect to the response page if all conditions are met
    let uri = '/profile/view-response/' + id;
    this.router.navigateByUrl(uri);
  }

  getPlaceholderText(): string {
    switch (this.activeTab) {
      case 'featureReview':
        return 'Type in full address to find representative(s) for a given office';
      case 'trendingReview':
        return 'Type in the full address (house no, street name, city, state, zip code) for precise results';
      case 'election':
        return 'Type in full address to find candidate(s) on the ballot';
      default:
        return '';
    }
  }

  copyToClipboard(inputElement: HTMLInputElement) {
    inputElement.select();
    document.execCommand('copy');
  }

  openShareModal(event: Event, id: any) {
    event.stopPropagation();
    setTimeout(() => {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      this.currentUrl = `${baseUrl}/profile/view-response/${id}`;
      $('#shareModal').modal('show');
    }, 100);
  }
  conversationmodal(event: Event) {
    event.stopPropagation();
    $('#conversationErrorModal').modal('show');
    // $('#conversationAlertModal').modal('show');
  }
  verifymodal() {
    $('#conversationAlertModal').modal('hide');
    $('#conversationErrorModal').modal('hide');
    $('#veriffModal').modal('show');
    console.log('veriff show');
    const veriff = Veriff({
      host: 'https://stationapi.veriff.com',
      apiKey: '836b96b7-c19a-48c0-a514-2ac42f77ed5e',
      parentId: 'veriff-root',
      onSession: (err: any, response: any) => {
        console.log('veriff data : ' + JSON.stringify(response));
        (window as any).veriffSDK.createVeriffFrame({
          url: response.verification.url,
          onEvent: (msg: string) => { 
            console.log(msg);
            if (msg == 'FINISHED') {
              console.log('verificaion finished');
              const params = new HttpParams().set(
                'userId',
                this.user.userId.toString()
              );
              this.userService.getUserDetail(params).subscribe((res: any) => {
                const respData = res;
                if (respData.success == 0) {
                  this.user = this.authService.getUser();
                  if (respData.data.veriffStatus == 'rejection' || respData.data.veriffStatus == 'declined') {
                    this.veriffStatus = respData.data.veriffStatus;
                    $('#verificationErrorModel').modal('show');
                    this.user.verified = true;
                    this.user.veriffFlag = true;
                    this.updateUser();

                  } else {
                    var user = this.authService.getUser();
                    if (respData.data.address != user.address) {
                      $('#AddressUpdateModal').modal('show');
                    }
                    this.user.address = respData.data.address;
                    this.user.city = respData.data.city;
                    this.user.state = respData.data.state;
                    this.user.country = respData.data.country;
                    this.authService.setSessionData(this.user);
                    this.getRepresentative();
                  }
                }
              });
            }
          },
        });
        $('#veriffModal').modal('hide');
        this.veriffSessionId = response.verification.id;
        const params = new HttpParams()
          .set('userId', this.user.userId.toString())
          .set('sessionId', response.verification.id);
        this.userService.veriffDetails(params).subscribe((res) => {
          console.log('veriff api response:' + JSON.stringify(res));
          const respData = res;
          if (respData.success == 1) {
            this.veriffErrMsg = respData.message;
          } 
        })
      },
    });
    veriff.setParams({
      person: {
        givenName: this.user.firstName,
        lastName: this.user.lastName,
      },
      vendorData: this.user.userId.toString(),
    });
    veriff.mount({});
  }
  feedbackmodal() {
    $('#conversationAlertModal').modal('hide');
    $('#conversationErrorModal').modal('hide');
    $('#FeedbackModal').modal('show');
  }

  getRepresentative() {
    let address = this.user.address;
    if (address != null) {
    address = address.replace(/\n/g, ' ');
    const params = new HttpParams().set('address', address);
    this.loaderService.disable = true;

    this.profileService.getReprentatives(params).subscribe((res) => {
      if (res.success === 0) {
        this.representativeList = [];
        console.log(JSON.stringify(res));
        res.data.forEach((obj: any) => {
          this.representativeList.push(obj.tagname);
        });
        console.log('Representative List:' + JSON.stringify(this.representativeList));
        this.authService.setRepresentativeList(this.representativeList);
        // window.location.reload();
      }
    });
  }
  }

  resetFormData(form: NgForm) {
    form.resetForm();
    this.reportBugFeedbackDTO = new ReportBugFeedbackDTO();
  }

  sendBugReportOrFeedback(form: NgForm) {
    if (form.invalid) {
      console.log("form in valid value:", form.value)
      return;
    }
    this.reportBugFeedbackDTO.userId = this.user.userId;

    this.userService
      .sendBugReportOrFeedback(this.reportBugFeedbackDTO)
      .subscribe((res: any) => {
        const respData = res;
        if (respData.success == 0) {
          $('#FeedbackModal').modal('hide');
          this.resetFormData(form);
        } else {
          $('#FeedbackModal').modal('hide');
          this.resetFormData(form);
          console.log('Error while sending report bug or feedback');
        }
      });
  }

  // Purpose : For updating user
  updateUser() {
    this.userService.editUser(this.user).subscribe((res) => {
      this.authService.setSessionData(this.user);
      if (res.success == 0) {
        console.log('User updated successfully:' + JSON.stringify(this.user));
      } else {
        console.log('Error while updating user');
      }
    });
  }

}
